module.exports = __webpack_public_path__ + "static/media/waiting-patients-white.fc73a6b0.svg";